import React from 'react';
import Box from '../Box/Box';
import Icon from '../Icon/Icon';

type TAttribute = {
  icon: string;
  title: string;
  description: string;
};

const MultilineAttribute = ({ icon, title, description, ...rest }: TAttribute) => (
  <Box {...rest} as="div" name="MultilineAttribute">
    <Icon name={icon} />
    <Box as="div" name="wrap" parent="MultilineAttribute">
      <Box as="p" name="title" parent="MultilineAttribute">
        {title}
      </Box>
      <Box as="p" name="description" parent="MultilineAttribute">
        {description}
      </Box>
    </Box>
  </Box>
);

export default MultilineAttribute;
